(function() {
    function initCustomSelect() {
        const customSelects = document.querySelectorAll('.contact-form .custom-select');

        if (!customSelects.length) {
            return;
        }

        customSelects.forEach((select, index) => {
            if (select.dataset.initialized === 'true') {
                return;
            }

            const trigger = select.querySelector('.custom-select__trigger');
            const dropdown = select.querySelector('.custom-select__dropdown');
            const options = select.querySelectorAll('.custom-select__option');
            const hiddenInput = select.querySelector('input[type="hidden"]');
            const placeholder = select.querySelector('.custom-select__placeholder');
            const searchInput = select.querySelector('.custom-select__search-input');

            if (!trigger || !dropdown) {
                return;
            }

            select.dataset.initialized = 'true';

            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = select.classList.contains('custom-select--open');

                document.querySelectorAll('.custom-select--open').forEach(s => {
                    if (s !== select) {
                        s.classList.remove('custom-select--open');
                    }
                });

                select.classList.toggle('custom-select--open');

                if (!isOpen && searchInput) {
                    setTimeout(() => searchInput.focus(), 100);
                }
            });

            options.forEach(option => {
                option.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    options.forEach(opt => opt.classList.remove('custom-select__option--selected'));

                    this.classList.add('custom-select__option--selected');

                    // const value = this.dataset.value;
                    const text = this.querySelector('.custom-select__option-text').textContent.trim();

                    placeholder.textContent = text;
                    placeholder.classList.add('custom-select__placeholder--selected');
                    hiddenInput.value = text;

                    hiddenInput.dispatchEvent(new Event('change'));

                    const errorMessage = select.querySelector('.form-message.error');
                    if (errorMessage) {
                        errorMessage.style.display = 'none';
                    }

                    setTimeout(() => {
                        select.classList.remove('custom-select--open');
                    }, 150);
                });
            });

            if (searchInput) {
                searchInput.addEventListener('input', function() {
                    const searchTerm = this.value.toLowerCase();

                    options.forEach(option => {
                        const text = option.querySelector('.custom-select__option-text').textContent.toLowerCase();
                        if (text.includes(searchTerm)) {
                            option.style.display = '';
                        } else {
                            option.style.display = 'none';
                        }
                    });
                });

                searchInput.addEventListener('click', e => {
                    e.stopPropagation();
                });
            }

            let currentIndex = -1;

            trigger.setAttribute('tabindex', '0');

            trigger.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    select.classList.toggle('custom-select--open');
                } else if (e.key === 'Escape') {
                    select.classList.remove('custom-select--open');
                } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault();

                    if (!select.classList.contains('custom-select--open')) {
                        select.classList.add('custom-select--open');
                    }

                    const visibleOptions = Array.from(options).filter(opt => opt.style.display !== 'none');

                    if (e.key === 'ArrowDown') {
                        currentIndex = (currentIndex + 1) % visibleOptions.length;
                    } else {
                        currentIndex = currentIndex <= 0 ? visibleOptions.length - 1 : currentIndex - 1;
                    }

                    visibleOptions.forEach((opt, i) => {
                        opt.classList.toggle('custom-select__option--hover', i === currentIndex);
                    });

                    if (visibleOptions[currentIndex]) {
                        visibleOptions[currentIndex].scrollIntoView({ block: 'nearest' });
                    }
                }
            });
        });

        if (!window.customSelectInitialized) {
            window.customSelectInitialized = true;

            document.addEventListener('click', function(e) {
                if (!e.target.closest('.custom-select')) {
                    document.querySelectorAll('.custom-select--open').forEach(select => {
                        select.classList.remove('custom-select--open');
                    });
                }
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCustomSelect);
    } else {
        setTimeout(initCustomSelect, 100);
    }

    window.initCustomSelect = initCustomSelect;
})();